import type { RouteWithTitle } from '@pbk-web/types';
import { Roles } from '@pbk-web/types';
import { lazy } from 'react';

const devRoutes: RouteWithTitle[] = [
  {
    id: 'dev-tokens',
    path: '/admin/dev-tokens',
    translationKey: 'page.dev-tokens',
    permissions: [Roles.SuperAdmin],
    component: lazy(() => import('../pages/dev/DevTokensPage')),
  },
  {
    id: 'dev-lexical',
    path: '/labs/lexical',
    translationKey: 'page.dev-lexical',
    component: lazy(() => import('../pages/dev/DevLexical')),
    // Public so the editor can be debugged without logging in
    publicPage: true,
    layout: 'Minimal',
  },
  {
    id: 'dev-icons',
    path: '/admin/dev-icons',
    translationKey: 'page.dev-icons',
    permissions: [Roles.SuperAdmin],
    component: lazy(() => import('../pages/dev/DevIconsPage')),
  },
] as RouteWithTitle[];

export default devRoutes;
